



























































import {Component, Mixins} from 'vue-property-decorator';
import SettingsTabMixin from '@/mixins/settings/SettingsTabMixin';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CTable from '@/components/base/table/CTable.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import DescriptionsContainerMixin from '@/mixins/DescriptionsContainerMixin';
@Component({
    components: {CSelect, CTable, CNumberField},
})
export default class BasePrimeCost extends Mixins(SettingsTabMixin, DescriptionsContainerMixin) {
    get tableHeaders() {
        return [
            {
                value: 'IdPlywoodSurface',
                text: this.$t('Catalogues.Plywoods.PlywoodSurface.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.plywoodSurface),
                ),
            },
            {
                value: 'Primecost',
                text: `${this.$t('Systems.Settings.AdvancedPrimecost')} ${this.$t('Common.Currency_Ruble')}/${this.$t(
                    'Common.M3',
                )}`,
            },
        ];
    }
}
